import { FINANCE, LEASING, SALES, VERTICAL_TYPES, VerticalType } from '../../types/vertical.type';

type VerticalTypeInput = VerticalType | { verticalType: VerticalType };

type NullableVerticalTypeInput = VerticalTypeInput | undefined | null;

function getVerticalType(verticalType: VerticalTypeInput): VerticalType {
  return typeof verticalType === 'string' ? verticalType : verticalType.verticalType;
}

export function isVerticalType(value: string): value is VerticalType {
  return (VERTICAL_TYPES as readonly string[]).includes(value);
}

export function isSalesVertical(verticalType: NullableVerticalTypeInput): boolean {
  return verticalType ? getVerticalType(verticalType) === SALES : false;
}

export function isLeasingVertical(verticalType: NullableVerticalTypeInput): boolean {
  return verticalType ? getVerticalType(verticalType) === LEASING : false;
}

export function isFinanceVertical(verticalType: NullableVerticalTypeInput): boolean {
  return verticalType ? getVerticalType(verticalType) === FINANCE : false;
}
